"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _api = require("../../api/api");
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
var _util = require("../../assets/static/js/utils/util");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _default = exports.default = {
  name: 'message-login',
  inject: ['reload'],
  props: ['loginType', 'landingPageJumpLink', 'pageId', 'userId', 'template', 'uuid'],
  data: function data() {
    return {
      yamImg: '',
      //验证码图片
      showPopup: false,
      //控制弹窗显示隐藏
      codeBtnShow: true,
      //控制验证码按钮
      count: '',
      //验证码按钮倒计时
      timer: null,
      //定时器timer
      tips: "拖动左边滑块完成上方拼图",
      visible: false,
      //拼图弹窗标记符
      slider: {
        mx: 0,
        bx: 0
      },
      //滑块x轴数据
      puzzle: false,
      //拼图是否正确
      regForm: {
        validatePhone: '',
        validateCode: '',
        ticket: '',
        //验证码图片的ticket值
        captcha: '' //动态验证码
      },
      regRules: {
        validatePhone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        validateCode: [{
          required: true,
          message: '请输入短信验证码',
          trigger: 'blur'
        }],
        captcha: [{
          required: true,
          message: '请输入短信验证码',
          trigger: 'blur'
        }]
      },
      submitDisabled: false //登录注册按钮的disable控制
    };
  },
  watch: {
    // visible(e) {
    // 	if (e === true) {
    // 		this.canvasInit();
    // 		this.puzzle = false;
    // 	}
    // }
  },
  mounted: function mounted() {
    // let mainDom = document.querySelector('#codeImg2');
    // let bg = mainDom.getContext("2d");
    // let width = mainDom.width;
    // let height = mainDom.height;
    // let blockDom = document.querySelector("#sliderBlock2");
    // let block = blockDom.getContext("2d");
    // //重新赋值，让canvas进行重新绘制
    // blockDom.height = height;
    // mainDom.height = height;

    // let imgsrc = require("../../assets/static/img/qrCode_01.jpg");
    // let img = document.createElement("img");
    // img.style.objectFit = "scale-down";
    // img.src = imgsrc;
    // img.onload = function() {
    // 	bg.drawImage(img, 0, 0, width, height);
    // 	block.drawImage(img, 0, 0, width, height);
    // };
  },
  methods: {
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？').then(function (_) {
        done();
      }).catch(function (_) {});
    },
    //拼图验证码初始化
    canvasInit: function canvasInit() {
      //生成指定区间的随机数
      var random = function random(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
      };
      //x: 254, y: 109
      var mx = random(140, 244),
        bx = random(10, 128),
        y = random(10, 99);
      this.slider = {
        mx: mx,
        bx: bx
      };
      this.draw(mx, bx, y);
    },
    //鼠标按下
    drag: function drag(e) {
      var _this = this;
      console.log("鼠标按下", e);
      var dom = e.target; //dom元素
      var slider = document.querySelector("#sliderBlock2"); //滑块dom
      var downCoordinate = {
        x: e.x,
        y: e.y
      };
      //正确的滑块数据
      var checkx = Number(this.slider.mx) - Number(this.slider.bx);
      //x轴数据
      var x = 0;
      var move = function move(moveEV) {
        x = moveEV.x - downCoordinate.x;
        //y = moveEV.y - downCoordinate.y;
        if (x >= 251 || x <= 0) return false;
        dom.style.left = x + "px";
        //dom.style.top = y + "px";
        slider.style.left = x + "px";
      };
      var up = function up() {
        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", up);
        dom.style.left = "";
        console.log(x, checkx);
        var max = checkx + 20;
        var min = checkx - 10;
        //允许正负误差1
        if (max >= x && x >= min || x === checkx) {
          console.log("滑动解锁成功");
          _this.puzzle = true;
          _this.tips = "验证成功";
          setTimeout(function () {
            _this.visible = false;
            _this.toGetCode();
          }, 500);
        } else {
          console.log("拼图位置不正确");
          _this.tips = "验证失败，请重试";
          _this.puzzle = false;
          _this.canvasInit();
        }
      };
      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", up);
    },
    draw: function draw() {
      var mx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
      var bx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
      var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
      var mainDom = document.querySelector("#codeImg2");
      var bg = mainDom.getContext("2d");
      var width = mainDom.width;
      var height = mainDom.height;
      var blockDom = document.querySelector("#sliderBlock2");
      var block = blockDom.getContext("2d");
      //重新赋值，让canvas进行重新绘制
      blockDom.height = height;
      mainDom.height = height;
      var imgsrc = require("../../assets/static/img/hall/jiaoyibj.png");
      var img = document.createElement("img");
      img.style.objectFit = "scale-down";
      img.src = imgsrc;
      img.onload = function () {
        bg.drawImage(img, 0, 0, width, height);
        block.drawImage(img, 0, 0, width, height);
      };
      var mainxy = {
        x: mx,
        y: y,
        r: 9
      };
      var blockxy = {
        x: bx,
        y: y,
        r: 9
      };
      this.drawBlock(bg, mainxy, "fill");
      this.drawBlock(block, blockxy, "clip");
    },
    //绘制拼图
    drawBlock: function drawBlock(ctx) {
      var xy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        x: 254,
        y: 109,
        r: 9
      };
      var type = arguments.length > 2 ? arguments[2] : undefined;
      var x = xy.x,
        y = xy.y,
        r = xy.r,
        w = 40;
      var PI = Math.PI;
      //绘制
      ctx.beginPath();
      //left
      ctx.moveTo(x, y);
      //top
      ctx.arc(x + (w + 5) / 2, y, r, -PI, 0, true);
      ctx.lineTo(x + w + 5, y);
      //right
      ctx.arc(x + w + 5, y + w / 2, r, 1.5 * PI, 0.5 * PI, false);
      ctx.lineTo(x + w + 5, y + w);
      //bottom
      ctx.arc(x + (w + 5) / 2, y + w, r, 0, PI, false);
      ctx.lineTo(x, y + w);
      ctx.arc(x, y + w / 2, r, 0.5 * PI, 1.5 * PI, true);
      ctx.lineTo(x, y);
      //修饰，没有会看不出效果
      ctx.lineWidth = 1;
      ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
      ctx.strokeStyle = "rgba(255, 255, 255, 0.5)";
      ctx.stroke();
      ctx[type]();
      ctx.globalCompositeOperation = "xor";
    },
    //生成随机字符串
    randAll: function randAll(m) {
      var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var result = '';
      for (var i = 0; i < m; i++) {
        var randomIndex = Math.floor(Math.random() * chars.length);
        result += chars[randomIndex];
      }
      return result;
    },
    //获取验证码图片
    getCaptcha: function () {
      var _getCaptcha = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var param, _yield$apiCaptcha, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              param = {
                ticket: this.randAll(32)
              };
              _context.next = 3;
              return (0, _api.apiCaptcha)(param);
            case 3:
              _yield$apiCaptcha = _context.sent;
              data = _yield$apiCaptcha.data;
              if (data.proCode == 200) {
                this.showPopup = true;
                this.regForm.captcha = ''; //打开弹窗重置内容
                this.yamImg = data.proData.image;
                this.regForm.ticket = data.proData.ticket;
              } else {
                this.showPopup = true;
                that.$message({
                  message: '获取验证码图片失败，请稍后再试!',
                  type: 'error'
                });
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCaptcha() {
        return _getCaptcha.apply(this, arguments);
      }
      return getCaptcha;
    }(),
    // 发送验证码
    toGetCode: function toGetCode() {
      if (!this.regForm.validatePhone) {
        this.$message({
          message: '请先输入手机号',
          type: 'error'
        });
        return;
      }
      return this.getCaptcha();
      var that = this;

      // let timestamp = parseInt(new Date().getTime() / 1000) + ""
      // let str = timestamp + that.regForm.validatePhone + "2"
      // let param = {
      // 	phone: that.regForm.validatePhone,
      // 	type: '2', //验证码类型  0、注册   1、忘记密码 2、单纯发验证码（登录注册一体接口要传2了）
      // 	timestamp: timestamp,
      // 	sign: CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(str, 'xiamenjinye'))
      // };
      // // let paramStr = JSON.stringify(param)
      // let param2 = {
      // 	fun: 'sendVerificationCode',
      // 	param: param,
      // 	version: 1
      // }
      // let codeParam = {
      // 	jsonParamete: JSON.stringify(param2)
      // }
      var param = {
        phone: that.regForm.validatePhone,
        ticket: that.regForm.ticket,
        //验证码图片的ticket值
        captcha: that.regForm.captcha,
        //动态验证码
        type: 0,
        sourceType: 10
      };
      that.getCode(param);
    },
    getCode: function () {
      var _getCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(param) {
        var that, TIME_COUNT, _yield$apiGetCode, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              TIME_COUNT = 60;
              _context2.next = 4;
              return (0, _api.apiGetCode)(param);
            case 4:
              _yield$apiGetCode = _context2.sent;
              data = _yield$apiGetCode.data;
              if (data.proCode == '200') {
                // console.log(data)
                this.showPopup = false;
                that.$message({
                  message: '发送成功!',
                  type: 'success'
                });
                // 验证码倒计时
                if (!that.timer) {
                  that.count = TIME_COUNT;
                  that.codeBtnShow = false;
                  that.timer = setInterval(function () {
                    if (that.count > 0 && that.count <= TIME_COUNT) {
                      that.count--;
                    } else {
                      that.codeBtnShow = true;
                      clearInterval(that.timer);
                      that.timer = null;
                    }
                  }, 1000);
                }
              } else {
                this.getCaptcha();
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getCode(_x) {
        return _getCode.apply(this, arguments);
      }
      return getCode;
    }(),
    changeShowPopup: function changeShowPopup() {
      var that = this;
      var param = {
        phone: that.regForm.validatePhone,
        ticket: that.regForm.ticket,
        //验证码图片的ticket值
        captcha: that.regForm.captcha,
        //动态验证码
        type: 0,
        sourceType: 10
      };
      that.getCode(param);
    },
    // 注册
    toReg: function toReg(formName) {
      var _this2 = this;
      this.$refs[formName].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          var _that, param, paramStr, reqParam;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!valid) {
                  _context3.next = 11;
                  break;
                }
                _that = _this2;
                if (_that.loginType == 'MARKETING_PAGE' || _that.loginType == 'REG_PAGE') {
                  // 注册落地页注册的
                  param = {
                    phone: _that.regForm.validatePhone,
                    verificationCode: _that.regForm.validateCode,
                    userPassword: '',
                    userId: _that.$route.name == 'reg_first' || _that.$route.name == 'reg_second' || _that.$route.name == 'reg_third' || _that.$route.name == 'landingpage' || _that.$route.name == 'regpage' ? _this2.uuid ? _this2.uuid : _this2.userId ? _this2.userId : '' : '',
                    regSource: 'PC',
                    regScene: _that.loginType,
                    regSceneId: _this2.pageId ? _this2.pageId : ''
                  };
                } else {
                  param = {
                    phone: _that.regForm.validatePhone,
                    verificationCode: _that.regForm.validateCode,
                    userPassword: '',
                    userId: _this2.userId ? _this2.userId : '',
                    regSource: 'PC',
                    regScene: _this2.$root.loginscene,
                    regSceneId: _this2.$root.loginsceneid
                  };
                }
                paramStr = {
                  fun: 'verificationcodelogin',
                  param: param,
                  version: 1
                };
                reqParam = {
                  jsonParamete: JSON.stringify(paramStr)
                };
                _this2.submitDisabled = true;
                _context3.next = 8;
                return _that.regTo(reqParam);
              case 8:
                if (_that.$root.isLogin) _this2.reload();
                _context3.next = 13;
                break;
              case 11:
                console.log('error submit!!');
                return _context3.abrupt("return", false);
              case 13:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    regTo: function () {
      var _regTo = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(param) {
        var that, _yield$apiGetReg, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              that = this;
              _context4.next = 3;
              return (0, _api.apiGetReg)(param);
            case 3:
              _yield$apiGetReg = _context4.sent;
              data = _yield$apiGetReg.data;
              if (data.proCode == '200') {
                // session替换成cookie
                (0, _cookie.setCookie)('user', JSON.stringify(data.proData), 24 * 60 * 60); //存入用户消息，设置有效时间1天
                (0, _cookie.setCookie)('token', data.proData.token, 24 * 60 * 60);
                // window.sessionStorage.setItem('user', JSON.stringify(data.proData))
                // setTimeLocal('token', data.proData.token, 7 * 24 * 60 * 60000)
                that.$root.dialogFormVisible = false;
                that.$root.token = data.proData.token;
                this.$refs.regForm.resetFields();
                this.$emit('loginStatus', true);
                that.$message({
                  message: '登录成功!',
                  type: 'success'
                });
                that.$root.isLogin = true;
                if (that.loginType == 'MARKETING_PAGE' && that.landingPageJumpLink != '') {
                  window.location.href = that.landingPageJumpLink;
                } else if (that.loginType == 'MARKETING_PAGE' && that.landingPageJumpLink == '') {
                  that.$router.push({
                    name: 'home'
                  });
                } else if (that.loginType == 'REG_PAGE') {
                  that.$router.push({
                    name: 'home'
                  });
                  // //跳转下载页
                  // setTimeout(function() {
                  // 	window.location.href = that.$root.baseUrl + '/pcDownload.dhtml?ncrypt=()(c)L33E/NY32aX1VkUU366w=='
                  // }, 1000);
                }
              }
              that.submitDisabled = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function regTo(_x3) {
        return _regTo.apply(this, arguments);
      }
      return regTo;
    }()
  }
};